import React, { useState } from 'react';

import ShowMoreBtn from '../../components/show_more_btn/show_more_btn';

import styles from './qna_list.module.css';

const QnaList = ({ list, title }) => {
  const [open, setOpen] = useState(null);
  const toggleOpen = (index) => {
    open === index ? setOpen(null) : setOpen(index);
  };

  return (
    <div className={styles.container}>
      {title ? <h3 className={styles.title}> 더 궁금한 점이 있나요?</h3> : null}

      <ul className={styles.list}>
        {list.map((item, index) => {
          const { question, answer } = item;
          return (
            <li
              onClick={() => toggleOpen(index)}
              className={styles.item}
              key={index}
            >
              <div className={styles.question}>
                <span>{question}</span>
                {
                  <span className={open === index ? styles.open : styles.close}>
                    {open === index ? '-' : '+'}
                  </span>
                }
              </div>

              {open === index ? (
                <div
                  className={styles.answer}
                  dangerouslySetInnerHTML={{ __html: answer }}
                />
              ) : null}
            </li>
          );
        })}
      </ul>
      <ShowMoreBtn title={'FAQ'} url='/support/faq' />
    </div>
  );
};

export default QnaList;
